import dashboardService from 'live/services/dashboard'
import React from 'react'

dashboardService.dashboardDecoratorRegistry.register(NavigatorDecorator)

const Panels = React.lazy(() => import('./Panels'))

function NavigatorDecorator({ children, ...props }): JSX.Element {
    const install = props?.dashboard?.widgets.some(w => w?.jsonConfig?.properties.some(p => p?.query?.expression?.indexOf("true as enableAssetFiltersPanel") >= 0))

    if (install) {
        const els = document.getElementsByClassName('dashboard-content')
        if (els && els.length > 0) {
            els[0].style.paddingBottom = '0px'
        }

        return <React.Suspense fallback={() => 'loading'}><Panels {...props}>{children}</Panels></React.Suspense>
    }

    return children
}
